// extracted by mini-css-extract-plugin
module.exports = {"cimemaWrapper":"cimemaWrapper___1ygMc","navBar":"navBar___3jl6k","barWrapper":"barWrapper___2TdEP","menu":"menu___3gSoU","bg":"bg___2Ifzl","dfMenuWrapper":"dfMenuWrapper___3_7dR"};